import React from 'react';

const Fallback: React.FC = () => <div>An error has occurred</div>;

export default Fallback;
